import { create, UseBoundStore } from 'zustand'
import { httpPost, timeoutError } from '../../common/HttpRequest';
import * as Urls from '../../common/Urls';
import { AppComponentState, useAppComponentStore } from '../../components/stores/appComponentStore';
import { LoginUserInfo } from '../../types/LoginUserInfo';

interface loginState {
    userCd:string,
    password:string,
    errMessage:[],
    changeUserCd:(value:string) => void,
    changePassword:(value:string) => void,
    thunkLogin:(appComponentStore:AppComponentState, userCd:string ,password:string) => void, 
}

export const useLoginStore = create<loginState>((set) => ({
    userCd:"",
    password:"",
    errMessage:[],
    /**
     * ユーザーCD変更
     * @param value 
     */
    changeUserCd: (value:string) => {
        set({userCd:value})
    },
    /**
     * パスワード変更
     * @param value 
     */
    changePassword: (value:string) => {
        set({password:value})
    },

    /**
     * ログイン
     * @param appComponentStore
     * @param userCd 
     * @param password 
     */
    thunkLogin : async ( appComponentStore ,user_cd, password) => {
        appComponentStore.progress.show();
        try
        {
            const form = new FormData();
            form.append("payload", JSON.stringify({
                userCd: user_cd,
                password: password
            }));

            await httpPost(Urls.URL_LOGIN + "?execute" ,form ,{
                "success" : (data :any) => {
                    if(data.status == 0){
                        // ログイン成功
                        set({errMessage:[]});

                        const loginUseInfo:LoginUserInfo = data.payload.user;
                        appComponentStore.loginUser = loginUseInfo; // ログイン情報を保持
                        
                        location.href = Urls.URL_DASHBOARD; // ダッシュボードへ
                    }else{
                        // ログインエラー
                        set({errMessage:data.messages})
                    }
                },
                "timeout" : () => {
                    throw new timeoutError();
                },
                "error" : (code:number , message:string) => {
                    throw new Error("Code:" + code + "Message:" + message);
                }
            });
        }
        catch(e){
            if(e instanceof timeoutError){
                // セッションタイムアウト
                location.href= Urls.URL_LOGIN + "?logout";
            }else{
                alert(e);
            }
        }finally{
            appComponentStore.progress.hide();
	    }
    },

}))